import { render } from "./OilfieldIT.vue?vue&type=template&id=5b907b96"
import script from "./OilfieldIT.vue?vue&type=script&lang=js"
export * from "./OilfieldIT.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__